"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PayspaceProvider = PayspaceProvider;
exports.usePayspace = void 0;
exports.usePayspaceUpdater = usePayspaceUpdater;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _payspaceNotFound = require("./payspace-not-found");

var _core = require("@slyk/core");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Initial payspace data.
 */
var initialPayspaceData = null;

try {
  var rawPayspace = window._payspace; // eslint-disable-line no-underscore-dangle

  if (rawPayspace) {
    var _parseObject;

    initialPayspaceData = (_parseObject = (0, _core.parseObject)(rawPayspace)) !== null && _parseObject !== void 0 ? _parseObject : {};
  }
} catch (error) {// Ignore, the Payspace Not Found page will be rendered.
}
/**
 * Payspace context.
 */
// This should only be used inside a subdomain,
// so Payspace should never be null when this context is used.
// $FlowFixMe


var PayspaceContext = /*#__PURE__*/(0, _react.createContext)(initialPayspaceData);
/**
 * Export `usePayspace`.
 */

var usePayspace = function usePayspace() {
  return (0, _react.useContext)(PayspaceContext);
};
/**
 * `PayspaceUpdate` type.
 */


exports.usePayspace = usePayspace;

/**
 * Payspace updater context.
 */
var PayspaceUpdaterContext = /*#__PURE__*/(0, _react.createContext)(function () {});
/**
 * Export `usePayspaceUpdater`.
 */

function usePayspaceUpdater() {
  return (0, _react.useContext)(PayspaceUpdaterContext);
}
/**
 * `Props` type.
 */


/**
 * Export `PayspaceProvider` container.
 */
function PayspaceProvider(props) {
  var backgroundImage = props.backgroundImage,
      backgroundOverlay = props.backgroundOverlay,
      children = props.children,
      earlyAccessLink = props.earlyAccessLink,
      imageMobile = props.imageMobile,
      logoLink = props.logoLink,
      supportEmail = props.supportEmail;

  var _useState = (0, _react.useState)(function () {
    return initialPayspaceData;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      payspace = _useState2[0],
      setPayspace = _useState2[1];

  var updatePayspace = (0, _react.useCallback)(function (update) {
    var greeting = update.greeting,
        logo = update.logo,
        name = update.name,
        signupMode = update.signupMode,
        status = update.status,
        title = update.title;
    setPayspace(function (payspace) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, payspace), name ? {
        name: name
      } : {}), greeting ? {
        greeting: greeting
      } : {}), logo !== undefined ? {
        logo: logo
      } : {}), signupMode ? {
        signupMode: signupMode
      } : {}), status ? {
        status: status
      } : {}), title ? {
        title: title
      } : {});
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(PayspaceUpdaterContext.Provider, {
    value: updatePayspace
  }, /*#__PURE__*/_react["default"].createElement(PayspaceContext.Provider, {
    value: payspace
  }, !(0, _isEmpty2["default"])(payspace) ? children : /*#__PURE__*/_react["default"].createElement(_payspaceNotFound.PayspaceNotFound, {
    backgroundImage: backgroundImage,
    backgroundOverlay: backgroundOverlay,
    earlyAccessLink: earlyAccessLink,
    imageMobile: imageMobile,
    logoLink: logoLink,
    supportEmail: supportEmail
  })));
}